import { render, staticRenderFns } from "./StatusGroup.vue?vue&type=template&id=353dad92&scoped=true&"
import script from "./StatusGroup.vue?vue&type=script&lang=js&"
export * from "./StatusGroup.vue?vue&type=script&lang=js&"
import style0 from "./StatusGroup.vue?vue&type=style&index=0&id=353dad92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353dad92",
  null
  
)

export default component.exports